import React from "react";
import { t } from "../../../../../dev/helpers/translator";
import Config from "../../../../../dev/config/main";
import LanguageSwitcher from "../../../../../dev/terminal/components/languageSwitcher";
import IndexLink from "react-router/es/IndexLink";
import Balance from "../../../../../dev/terminal/components/balance";
import Link from "react-router/es/Link";
import SearchInHeader from "../../../../../dev/terminal/components/searchInheader";
import CashdeskSubscriptionComponent from "../../../../../dev/terminal/components/cashdeskSubscriptionComponent";
//import { Jackpot } from "../../../../../dev/terminal/containers/jackpot";
//import { JackpotContextProvider } from "../../../../../dev/helpers/jackpot";
import CountDown from "../../../../../dev/terminal/components/countdownHook";
import { DepositModeEnum } from "../../../../../dev/constants/enums/depositMode";
import { OpenPopup } from "../../../../../dev/actions/ui";

export default function headerTemplate() {
	let { user, location, userBalance, terminalBalance } = this.props,
		depositMode = user.depositMode,
		userId = user.profile && user.profile.id,
		userName = user.profile && user.profile.username,
		pathName = location.pathname,
		loggedInAdmin = this.props.isAdminLoggedIn && this.props.isAdminLoggedIn;

	const openCashoutPopup = () => {
		const balance =
			sessionStorage.getItem("balance") &&
			JSON.parse(sessionStorage.getItem("balance")).session_balance;
		const finalBalance = userBalance || terminalBalance || balance || 0;
		if (depositMode === DepositModeEnum.Cash || !finalBalance) this.props.dispatch(OpenPopup("dmsCashout"));
		else this.props.dispatch(OpenPopup("cashoutByBankCard"));
	};

	return (
		<div className={`header-wrapper-t`}>
			{Config.terminal.enableAgeRestriction && (
				<p className="over-18">{t("Interzis persoanelor sub 18 ani")}</p>
			)}
			<div className="header-container-t">
				<div className="left-column-t">
					<div className="logo-wrapper">
						<IndexLink to="/" className="logo-v" activeClassName="active" />
						<IndexLink
							to="/"
							className="product-item-v home"
							activeClassName="active"
						/>
						{Config.headerItems.map(item => {
							return (
								item.enabled && (
									<Link
										to={`/${item.url}`}
										className={`product-item-v game  ${item.url}`}
										activeClassName="active"
										key={item.url}
									>
										{Config.openSectionNameOnClick ? (
											pathName.includes(item.url) && (
												<span>
													{t(item.name)}
												</span>
											)
										) : (
											<span>{t(item.name)}</span>
										)}
									</Link>
								)
							);
						})}
					</div>
				</div>
				{/* <div>
                <div className={`jackpot-content-m ${this.props.isAdminLoggedIn ? "jackpot-hidden" : ""}`}>
                    <JackpotContextProvider ><Jackpot /></JackpotContextProvider>
                </div>
            </div> */}
				<div className="right-column-t">
					<div className="nav-wrapper">
						<LanguageSwitcher />
						{Config.main.subscribeToCashdesk && <CashdeskSubscriptionComponent />}
						<div className="mini-naw-contain">
							<ul>
								{pathName === "/casino" && (
									<CasinoFavorites pathName={location.pathname} />
								)}
								{user.loggedIn && (
									<li>
										<div
											className={`single-nav-item ${
												this.state.userInfo &&
												"active"
											}`}
											onClick={this.setHandleClick(
												"userInfo"
											)}
										>
											<p>
												<i className="arrow-v-nav profile-v" />
											</p>
											<div className="open-d-view">
												<ul>
													{/* <li>{t("User Name: " + userName)}</li> */}
													<li>
														{"Id: " +
															userId}
													</li>
													{(user.loggedIn ||
														user.loggedInByRFID) && (
														<li>
															<div
																className="single-nav-item"
																onClick={this.props.openPopup(
																	"betHistory"
																)}
															>
																<p>
																	{t(
																		"Bet History"
																	)}
																</p>
															</div>
														</li>
													)}
													{/* {
                                                    (user.loggedIn || user.loggedInByRFID) && <li>
                                                        <div className="single-nav-item" onClick={this.showCasinoBetHistory}>
                                                            <p>{t("Casino Bet History")}</p>
                                                        </div>
                                                    </li>
                                                } */}
													{(user.loggedIn ||
														user.loggedInByRFID) && (
														<li>
															<div
																className="single-nav-item"
																onClick={this.props.openPopup(
																	"freeBetBonus"
																)}
															>
																<p>
																	{t(
																		"Bet Bonus"
																	)}
																</p>
															</div>
														</li>
													)}
													{(user.loggedIn ||
														user.loggedInByRFID) &&
														Config
															.main
															.rfidPinCode && (
															<li>
																<div
																	className="single-nav-item"
																	onClick={
																		this
																			.changePinCode
																	}
																>
																	<p>
																		{t(
																			"CHANGE PIN CODE"
																		)}
																	</p>
																</div>
															</li>
														)}
													{(user.loggedIn ||
														user.loggedInByRFID) &&
														Config
															.main
															.rfidPinCode && (
															<li>
																<div
																	className="single-nav-item"
																	onClick={this.props.openPopup(
																		"rules"
																	)}
																>
																	<p>
																		{t(
																			"Regulations"
																		)}
																	</p>
																</div>
															</li>
														)}
													{((user.loggedInByRFID &&
														Config
															.terminal
															.enableSignOutWithRfidButton) ||
														(user.loggedIn &&
															!user.loggedInByRFID)) && (
														<li
															className="logout-v"
															onClick={this.logOut()}
														>
															{t(
																"sign out"
															)}
														</li>
													)}
												</ul>
											</div>
										</div>
									</li>
								)}
							</ul>
						</div>
						<div className="mini-naw-contain">
							<ul>
								{!loggedInAdmin && (
									<li className="search-in-header">
										{Config.searchInHeader && (
											<SearchInHeader />
										)}
									</li>
								)}
								<li className="refresh-button">
									{loggedInAdmin &&
										Config.enableRefreshButton && (
											<button
												onClick={
													this
														.refreshButton
												}
												disabled={
													this.state
														.disableRefreshButton
												}
											></button>
										)}
								</li>
								<li>
									<Balance />
								</li>
								{/* {
                                !user.loggedIn && <li>
                                    <div className="single-nav-item" onClick={openCashoutPopup}>
                                        <p>{t("Cash out")}</p>
                                    </div>
                                </li>
                            } */}
								{Config.main.showDepositByHiPay && (
									<li>
										<div
											className="single-nav-item"
											onClick={openDepositPopup}
										>
											<p>{t("HiPay deposit")}</p>
										</div>
									</li>
								)}
								{!user.loggedIn && (
									<li>
										<div
											className="single-nav-item"
											onClick={openCashoutPopup}
										>
											<p>{t("Cash out")}</p>
										</div>
									</li>
								)}
								{user.loggedIn && (
									<li>
										<div
											className="single-nav-item"
											onClick={this.props.openPopup(
												"dmsLoggedInCashout"
											)}
										>
											<p>{t("Cash out")}</p>
										</div>
									</li>
								)}
								{Config.enableDepositMoney &&
									![
										DepositModeEnum.Cash,
										DepositModeEnum.None,
									].includes(depositMode) && (
										<li>
											<div
												className="single-nav-item"
												onClick={this.props.openPopup(
													"depositMoney"
												)}
											>
												<p>
													{t(
														"DEPOSIT BY BANK CARD"
													)}
												</p>
											</div>
										</li>
									)}
								{!Config.terminal.disableTicket && (
									<li
										onClick={this.props.openPopup(
											"ticketInManualCheck"
										)}
									>
										<div className="single-nav-item">
											<button className="button-view-t">
												{t("TICKET")}
											</button>
										</div>
									</li>
								)}
							</ul>
						</div>
						{Config.enableMultipleWinsPopup && !user.loggedInByRFID ? (
							<div
								className={`product-item-v ticket`}
								onClick={this.props.openPopup("multipleTicketsPopup")}
							>
								{this.props.timer ? (
									<span>
										<CountDown
											propsDefaultSecond={
												this.props.timer
											}
											endOfWork={
												this
													.ticketTimerEndOfWork
											}
										/>
									</span>
								) : (
									<span>
										{t("Tickets")}
										{this.props.tickets &&
										Object.keys(this.props.tickets).length >
											0
											? `(${
													Object.keys(
														this
															.props
															.tickets
													).length
											  })`
											: ""}
									</span>
								)}
							</div>
						) : null}
					</div>
				</div>
			</div>
		</div>
	);
}
